import { render, staticRenderFns } from "./StayExtend.vue?vue&type=template&id=844fab6e&scoped=true"
import script from "./StayExtend.vue?vue&type=script&lang=js"
export * from "./StayExtend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "844fab6e",
  null
  
)

export default component.exports